import React, { useState } from 'react';

import { Grid, TextField } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { NumberFieldFormat } from 'app/components/NumberFieldFormat/NumberFieldFormat';

let timeoutRGId: ReturnType<typeof setTimeout>;

export default function RangeForm({ range, updateRange }) {
  let _r = '0-0';
  if (range.length > 2) {
    _r = range.substring(1, range.length - 1);
  }

  const [from, setFrom] = useState(_r.split(',')[0]);
  const [to, setTo] = useState(_r.split(',')[1]);

  return (
    <section>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h6">{range.title}</Typography>
          <Typography variant="body1">{range.description}</Typography>
        </Grid>
        <Grid item xs={6}>
          <TextField
            name="from"
            label="Desde"
            defaultValue={from}
            onChange={e => {
              const _from = e.target.value;
              setFrom(_from);
              clearTimeout(timeoutRGId);
              timeoutRGId = setTimeout(() => {
                console.log('updating...' + _from);
                updateRange('[' + _from + ',' + to + ']');
              }, 1000);
            }}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            InputLabelProps={{ shrink: true }}
            InputProps={{
              inputComponent: NumberFieldFormat,
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            name="to"
            label="Hasta"
            defaultValue={to}
            onChange={e => {
              const _to = e.target.value;
              setTo(_to);
              console.log('timeoutRGId: ' + timeoutRGId);
              clearTimeout(timeoutRGId);
              timeoutRGId = setTimeout(() => {
                console.log('updating...' + _to);
                updateRange('[' + from + ',' + _to + ']');
              }, 1000);
            }}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            InputLabelProps={{ shrink: true }}
            InputProps={{
              inputComponent: NumberFieldFormat,
            }}
          />
        </Grid>
      </Grid>
    </section>
  );
}
